/*
 * View for the KnowledgeBase menu above the menu bar
 */

define([
  "marionette",
  "modules/header/kbMenu/template/kbItemTemplate.html",
  "modules/header/kbMenu/template/kbMenuTemplate.html",
], function (Marionette, KbItemTemplate, KbMenuTemplate) {
  var KbMenuView = {};

  KbMenuView.kbItemView = Marionette.ItemView.extend({
    template: KbItemTemplate,
    tagName: "li",
    triggers: {
      click: "click:kb",
    },
  });

  KbMenuView.kbMenuView = Marionette.CompositeView.extend({
    template: KbMenuTemplate,
    itemView: KbMenuView.kbItemView,
    itemViewContainer: "ul",
    collectionEvents: {
      sort: "render",
    },
    toggleDropdown: function () {
      this.$el.find(".dropdown-toggle").dropdown("toggle");
    },
    setResponseStylesLink: function (responseStylesUrl) {
      this.$el.find("#responseStylesLink").attr("href", responseStylesUrl);
    },
  });

  return KbMenuView;
});
